import {OfferType} from "../../offer/types/OfferType";
import {ISitemapRegionListRegion} from "../actions/fetch_site_map_region";

export const getRegionOfferCountByOfferType = (region: ISitemapRegionListRegion, offerType: OfferType) => {
    switch (offerType) {
        case OfferType.FLAT:
            return region.stats.properties_flats_count_for_sale;
        case OfferType.COMMERCIAL:
            return region.stats.properties_commercials_count_for_sale;
        case OfferType.HOUSE:
            return region.stats.properties_houses_count_for_sale;
        default:
            return null;
    }
};
import {OfferType} from "../../offer/types/OfferType";
import {ISitemapRegionListRegion} from "../actions/fetch_site_map_region";

export const getRegionOfferCountByOfferType = (region: ISitemapRegionListRegion, offerType: OfferType) => {
    switch (offerType) {
        case OfferType.FLAT:
            return region.stats.properties_flats_count_for_sale;
        case OfferType.COMMERCIAL:
            return region.stats.properties_commercials_count_for_sale;
        case OfferType.HOUSE:
            return region.stats.properties_houses_count_for_sale;
        default:
            return null;
    }
};
